import { useMemo } from 'react'
import { formatDeviceStatusDisplayName } from '../../modules/devices/deviceStatusColor'
import useNormalizedDeviceStatuses from './useNormalizedDeviceStatuses'

const deviceStatusToSelectOption = ({ id, name, color }) => ({
  value: id,
  label: formatDeviceStatusDisplayName(name),
  color,
  name
})

const useDeviceStatusesAsSelectOptions = () => {
  const deviceStatuses = useNormalizedDeviceStatuses()

  return useMemo(() => deviceStatuses.map(deviceStatusToSelectOption), [deviceStatuses])
}

export default useDeviceStatusesAsSelectOptions
